import type { InsertCustomDataSourceMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertCustomDataSourceDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { InsertCustomDatasourceInput } from '../nativeMutationInputs';
export type { InsertCustomDatasourceInput } from '../nativeMutationInputs';

export const useInsertCustomDatasource = createMutationHook({
  name: 'insertCustomDatasource',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.customDatasource.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertCustomDatasourceInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.customDatasource.customDatasources.queryKey(),
    trpc.frontend.customDatasource.customDatasourceById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertCustomDataSourceMutation => ({
    insert_custom_datasource_one: {
      __typename: 'custom_datasource',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertCustomDataSourceDocument,
  // evict the custom_datasource query families so the cache-first reads
  // (list + `useGetCustomDatasourceById`) refetch after a create, keeping
  // parity with the delete hook and the tRPC branch (RSP-6650).
  graphqlVariables: (input: InsertCustomDatasourceInput) => ({
    customDatasource: {
      Title: input.Title,
      Datasources: input.Datasources,
      Fields: input.Fields,
      Filters: input.Filters,
    },
  }),
  evictFields: ['custom_datasource', 'custom_datasource_by_pk'],
});
